var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass:
        "font-sans antialiased text-gray-900 leading-normal tracking-wider content feedback-content"
    },
    [
      _c(
        "div",
        {
          staticClass: "min-h-screen flex flex-col font-sans"
        },
        [
          _c(
            "div",
            {
              staticClass: "flex-grow"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "max-w-4xl h-auto flex items-center justify-center h-auto flex-wrap mx-auto my-28 lg:my-0"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-full lg:w-4/5 rounded-lg lg:rounded-lg shadow-2xl bg-white mx-6 lg:mx-0 my-16"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "p-4 md:p-12 text-center"
                        },
                        [
                          _vm._m(0),
                          _c("br"),
                          _vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-2 mb-6"
                                },
                                [_c("preloader")],
                                1
                              )
                            : _vm.loadError
                            ? _c(
                                "p",
                                {
                                  staticClass: "mt-2 mb-6 text-red-500"
                                },
                                [_vm._v(_vm._s(_vm.loadError))]
                              )
                            : _vm.complete
                            ? _c("div", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "text-lg font-bold pt-8 lg:pt-0"
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "h-6 w-6 fill-current inline-block ggs-green pb-1",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          viewBox: "0 0 44 44"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "m22,0c-12.2,0-22,9.8-22,22s9.8,22 22,22 22-9.8 22-22-9.8-22-22-22zm12.7,15.1l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.6-0.1-0.7-0.3l-7.8-8.4-.2-.2c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.3 0.4,0.9 0,1.3z"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(
                                      " Thank you! Your feedback has been received. "
                                    )
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass: "text-lg"
                                  },
                                  [_vm._v("You may now close this page.")]
                                )
                              ])
                            : [
                                _vm._m(1),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.feedback,
                                      expression: "feedback"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass:
                                    "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
                                  attrs: {
                                    "data-vv-as": "Feedback",
                                    "data-vv-name": "feedback",
                                    rows: "5"
                                  },
                                  domProps: {
                                    value: _vm.feedback
                                  },
                                  on: {
                                    input: function input($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.feedback = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-red-500 text-xs text-left"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.collect("feedback")[0]
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "pt-6"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "inline-flex bg-green-600 hover:bg-teal-900 text-white font-bold py-2 leading-normal px-4 rounded",
                                        attrs: {
                                          disabled: _vm.submitting
                                        },
                                        on: {
                                          click: _vm.submit
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.submitting,
                                                expression: "submitting"
                                              }
                                            ],
                                            staticClass:
                                              "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              fill: "none",
                                              viewBox: "0 0 24 24"
                                            }
                                          },
                                          [
                                            _c("circle", {
                                              staticClass: "opacity-25",
                                              attrs: {
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                "stroke-width": "4"
                                              }
                                            }),
                                            _c("path", {
                                              staticClass: "opacity-75",
                                              attrs: {
                                                fill: "currentColor",
                                                d:
                                                  "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" Submit Survey ")
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "mt-2 text-red-500"
                                      },
                                      [_vm._v(_vm._s(_vm.submitError))]
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ]
                  ),
                  _c("div", [
                    _c(
                      "footer",
                      {
                        staticClass: "bg-white"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "container max-w-4xl mx-auto my-28 lg:my-0 mx-auto"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex md:flex-row flex-col justify-around pt-6 text-center md:text-left"
                              },
                              [
                                _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "Copyright © 2008 - " +
                                        _vm._s(new Date().getFullYear()) +
                                        " GreenGeeks.com - All Rights Reserved."
                                    )
                                  ]),
                                  _c("p"),
                                  _vm._m(2)
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "flex justify-center"
      },
      [
        _c(
          "a",
          {
            staticClass: "no-underline hover:no-underline",
            attrs: {
              href: "https://www.greengeeks.com/"
            }
          },
          [
            _c("img", {
              staticClass: "mb-6",
              attrs: {
                alt: "GreenGeeks logo",
                src: "/static/img/amui/logo_black.png"
              }
            })
          ]
        )
      ]
    )
  } /* staticRenderFnsSpliter */,
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "flex justify-center"
      },
      [
        _c(
          "h4",
          {
            staticClass: "pb-4 font-bold"
          },
          [
            _vm._v(
              " Thank you for your feedback. What is the most important reason for your score? "
            )
          ]
        )
      ]
    )
  } /* staticRenderFnsSpliter */,
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "p",
      {
        staticClass: "copyright-links"
      },
      [
        _c(
          "a",
          {
            staticClass:
              "no-underline hover:underline text-gray-800 hover:text-green-600",
            attrs: {
              href: "https://www.greengeeks.com/legal/tos"
            }
          },
          [_vm._v("Terms of Service")]
        ),
        _vm._v(" / "),
        _c(
          "a",
          {
            staticClass:
              "no-underline hover:underline text-gray-800 hover:text-green-600",
            attrs: {
              href: "https://www.greengeeks.com/legal/privacy"
            }
          },
          [_vm._v("Privacy Policy")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }